import { Avatar, AvatarSize, FontWeight, Heading } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TeamMember } from '../../../../../types';

interface RoleItemUserDetailsProps {
  isCurrentUser: boolean;
  teamMember: TeamMember;
}

export const RoleItemUserDetails = ({ teamMember, isCurrentUser }: RoleItemUserDetailsProps) => {
  const { t } = useTranslation();

  const shouldShowName = teamMember.lastName && teamMember.firstName;
  return (
    <div className='flex flex-row items-center gap-2'>
      <Avatar
        name={shouldShowName ? `${teamMember.firstName} ${teamMember.lastName}` : teamMember.email}
        id={teamMember.firstName + teamMember.lastName}
        size={AvatarSize.MEDIUM}
      />
      <div className='flex flex-col'>
        {shouldShowName && (
          <Heading.H9 className='text-text-main-primary' fontWeight={FontWeight.MEDIUM}>
            {`${teamMember.firstName} ${teamMember.lastName}${isCurrentUser ? t('ACCOUNT_SETTINGS.TEAM.TABLE.CURRENT_USER_INDICATION') : ''}`}
          </Heading.H9>
        )}
        <Heading.H10 className='text-text-main-tertiary' fontWeight={FontWeight.REGULAR}>
          {teamMember.email}
        </Heading.H10>
      </div>
    </div>
  );
};
